<template>
	<standard-field v-model="value">
		<div class="input-container">
			<div class="input-title">Max Length</div>
			<div class="input-box">
				<input type="text" v-model="value.config.max_length" placeholder="Enter max length of the textarea">
			</div>
		</div>
	</standard-field>
</template>

<script>

import FieldMixin from './mixins/FieldMixin';

export default {

	mixins: [FieldMixin],

	mounted() {
		if (!this.value.config.max_length) {
			this.$set(this.value.config, 'max_length', 0);
		}
	}

};

</script>
